// extracted by mini-css-extract-plugin
export default {"container":"AssetInvestHolder_container__hSa1O","investProcess":"AssetInvestHolder_investProcess__xZ8tm","assetInvestStats":"AssetInvestHolder_assetInvestStats__w+Mm7"};